import { InputGroup } from "../../InputGroup-DnGP9-ZQ.js";
import { useControllableState } from "../../useControllableState-BCvUOC6G.js";
import { jsx } from "react/jsx-runtime";
// src/blocks/Textarea/Textarea.tsx
/** Multi-line text input in `InputGroup` chrome. */
const Textarea = ({ ref, containerClassName, state = "default", focusVariant, value: valueProp, defaultValue, onValueChange, ...rest }) => {
	const [value, setValue] = useControllableState({
		prop: valueProp === void 0 ? void 0 : valueProp ?? "",
		defaultProp: defaultValue ?? "",
		onChange: onValueChange
	});
	return /* @__PURE__ */ jsx(InputGroup, {
		state,
		focusVariant,
		className: containerClassName,
		children: /* @__PURE__ */ jsx(InputGroup.TextArea, {
			...rest,
			ref,
			value,
			onValueChange: setValue
		})
	});
};
export { Textarea };

//# sourceMappingURL=Textarea.js.map